import { render, staticRenderFns } from "./WebFooter.vue?vue&type=template&id=14854e33&scoped=true&"
import script from "./WebFooter.vue?vue&type=script&lang=js&"
export * from "./WebFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14854e33",
  null
  
)

export default component.exports